import {createAction} from '@ngrx/store';

export enum Actions {
  BRAK_OPERACJI = 'Brak operacji',
}

export const brakOperacjiAction = createAction(
  Actions.BRAK_OPERACJI
);
